import React from 'react';
import { HeartHandshakeIcon, LeafIcon, SchoolIcon } from 'lucide-react';
import { CompanyPageLayout } from '../components/CompanyPageLayout';
const commitments = [{
  icon: HeartHandshakeIcon,
  title: 'Keep value local',
  text: 'We prioritise locally owned stays, guides, drivers, and suppliers so more of each journey remains in the places travellers visit.'
}, {
  icon: LeafIcon,
  title: 'Tread with care',
  text: 'Small groups, refillable-water guidance, and thoughtful trail habits help reduce avoidable pressure on fragile mountain environments.'
}, {
  icon: SchoolIcon,
  title: 'Support the next generation',
  text: 'A portion of selected departures supports practical education materials and community-led initiatives in mountain areas.'
}];
export function CSR() {
  return <CompanyPageLayout eyebrow="CSR" title="Leave a lighter mark, together." intro="Responsible travel is not a separate project. It is how we choose partners, prepare guests, and show up in the places that make our journeys possible." data-id="element-411">
      <section className="px-5 py-20 sm:px-8 sm:py-28 lg:px-12" data-id="element-412">
        <div className="mx-auto max-w-[1180px]" data-id="element-413">
          <div className="grid gap-10 lg:grid-cols-[0.72fr_1.28fr]" data-id="element-414">
            <div data-id="element-415">
              <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#4f8057]" data-id="element-416">
                Our commitments
              </p>
              <h2 className="mt-4 font-serif text-4xl leading-tight sm:text-5xl" data-id="element-417">
                Travel that respects the welcome.
              </h2>
            </div>
            <p className="max-w-2xl text-lg leading-8 text-[#52635a]" data-id="element-418">
              We believe meaningful impact comes from consistency: choosing
              local relationships, being transparent with guests, and following
              the lead of communities rather than imposing an outside agenda.
            </p>
          </div>
          <div className="mt-12 grid gap-7 md:grid-cols-3" data-id="element-419">
            {commitments.map(({
            icon: Icon,
            title,
            text
          }) => <article key={title} className="border-t border-[#9eaa9e] pt-6" data-id="element-420">
                <Icon className="h-7 w-7 text-[#4f8057]" aria-hidden="true" data-id="element-421" />
                <h3 className="mt-6 font-serif text-3xl" data-id="element-422">{title}</h3>
                <p className="mt-4 leading-7 text-[#52635a]" data-id="element-423">{text}</p>
              </article>)}
          </div>
        </div>
      </section>
      <section className="bg-[#e1efdc] px-5 py-16 sm:px-8 lg:px-12" data-id="element-424">
        <div className="mx-auto grid max-w-[1180px] gap-6 sm:grid-cols-3" data-id="element-425">
          <div data-id="element-426">
            <p className="font-serif text-5xl" data-id="element-427">100%</p>
            <p className="mt-2 text-[10px] font-bold uppercase tracking-[0.16em] text-[#40564a]" data-id="element-428">
              Locally led journeys
            </p>
          </div>
          <div data-id="element-429">
            <p className="font-serif text-5xl" data-id="element-430">12+</p>
            <p className="mt-2 text-[10px] font-bold uppercase tracking-[0.16em] text-[#40564a]" data-id="element-431">
              Years of local partnerships
            </p>
          </div>
          <div data-id="element-432">
            <p className="font-serif text-5xl" data-id="element-433">Small</p>
            <p className="mt-2 text-[10px] font-bold uppercase tracking-[0.16em] text-[#40564a]" data-id="element-434">
              Group sizes by design
            </p>
          </div>
        </div>
      </section>
    </CompanyPageLayout>;
}